"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstrumentationNodeModuleFile = void 0;
const index_1 = require("./platform/index");
class InstrumentationNodeModuleFile {
    name;
    supportedVersions;
    patch;
    unpatch;
    constructor(name, supportedVersions, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    patch, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    unpatch) {
        this.name = (0, index_1.normalize)(name);
        this.supportedVersions = supportedVersions;
        this.patch = patch;
        this.unpatch = unpatch;
    }
}
exports.InstrumentationNodeModuleFile = InstrumentationNodeModuleFile;
//# sourceMappingURL=instrumentationNodeModuleFile.js.map